import { MessageHandlerBase } from "./MessageHandlerBase";
export default class PlatformDataRefreshHandler extends MessageHandlerBase {
    constructor(almeState, setAlmeState, appConfig, apiUtils, setAlmeAppConfig) {
        super(almeState, setAlmeState, appConfig, apiUtils);
        this.setAlmeAppConfig = setAlmeAppConfig;
    }
    handle(message) {
        if (message.platform &&
            message.platform === this.appConfig.main.platform &&
            message.platform === "PEAKS" &&
            message.platformInformationData) {
            const userdata = this.appConfig.main.userMetadata;
            const EnterpriseId = userdata.currentEnterpriseId;
            const peaksUserMetadata = {
                currentEnterpriseId: EnterpriseId,
                platformInformation: message.platformInformationData,
            };
            this.setAlmeAppConfig(Object.assign(Object.assign({}, this.appConfig), { main: Object.assign(Object.assign({}, this.appConfig.main), { userMetadata: peaksUserMetadata }) }));
        }
    }
}
